import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import AppFooter from '../components/AppFooter';

const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-3xl mx-auto px-6 py-16 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="flex justify-center mb-6">
            <CheckCircleIcon className="w-16 h-16 text-emerald-500" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Subscription activated</h1>
          <p className="text-gray-600 mb-8">Thanks for upgrading to Pro! Your account will update in a moment. You can return to your dashboard now.</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="px-6 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold hover:from-blue-700 hover:to-purple-700"
          >
            Back to dashboard
          </button>
        </motion.div>
      </main>
      <AppFooter />
    </div>
  );
};

export default BillingSuccess;


